import { Stack, Grid, Paper, TextField, Avatar, Button } from "@mui/material";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import ErrorPaper from '../components/ErrorPaper';

const PensieveBaseUri = 'http://api.epensieve.com';

function SignUp() {
    const paperStyle = {padding: 20, height: 450, width:300, margin:"50px auto"};
    const btnStyle = {margin:"35px auto"};

    const navigate = useNavigate();
    const url = `${PensieveBaseUri}/users`;

    const [formValues, setFormValues] = useState({username: '', password: '', name: ''});
    const handleInputChange = (evt : any) => {
        const {name, value} = evt.target;
        setFormValues({
            ...formValues,
            [name]: value
        });
    };

    const [error, setError] = useState<string | null>(null);

    const handleSubmit = (evt : FormEvent) => {
        evt.preventDefault();

        fetch(url, {method: 'POST',
            headers:{
                'Content-Type': 'application/json'
            }, 
            body: JSON.stringify(formValues)
        }).then((response) => {
            if (!response.ok) {
                throw new Error("User could not be created, try again with a different username.");
            }
            
            navigate('/login');
        }).catch((err) => {
            setError(err.message);
        });
    };

    return (
        <form onSubmit={handleSubmit}>
            { (error) && <ErrorPaper error={error} /> }
            <Paper elevation={10} sx={{minHeight:450}} style={paperStyle} >
                <Grid container spacing={2} direction='column' >
                    <Grid item sx={{marginBottom: 2}}>
                        <Grid container direction='column' alignItems='center' spacing={1} >
                            <Grid item>
                                <Avatar> <AddCircleIcon fontSize="medium" /> </Avatar>
                            </Grid>
                            <Grid item>
                                <h2> Create an Account </h2>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <TextField 
                            name='username'
                            label='Username'
                            placeholder='Enter username'
                            variant='standard'
                            value={formValues.username}
                            onChange={handleInputChange}
                            fullWidth
                            required />
                    </Grid>
                    <Grid item>
                        <TextField 
                            name='password'
                            label='Password'
                            placeholder='Enter password'
                            variant='standard'
                            type='password'
                            value={formValues.password}
                            onChange={handleInputChange}
                            fullWidth
                            required />
                    </Grid>
                    <Grid item>
                        <TextField 
                            name='name'
                            label='Name'
                            placeholder='Enter your display name'
                            variant='standard'
                            value={formValues.name}
                            onChange={handleInputChange}
                            fullWidth />
                    </Grid>
                    <Grid item>
                        <Button style={btnStyle} type='submit' color='primary' variant='contained' fullWidth >
                            Sign Up
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </form>
    );
}

export default SignUp;